// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3pbfh","rootCenter":"LoadMoreObserver_rootCenter__3tTV0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__6TJfT"};